/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext } from 'react';
import GlobalContext from '../../../Context/GloablContext';
import { downloadS3Object } from '../../../../CommonMethods/S3DownloadHook';

const ViewProfile = ({updateDocumentSate}) => {
    const {setToastmessage} = useContext(GlobalContext);

    /* The `DocList3` object is a data structure that stores information about various documents
    related to statutory details. It is organized into different lines (Line1, Line2, etc.), and
    each line contains multiple documents with their respective names and registration numbers. */
    const DocList3 =  {
        Line1: {
            pan_file_url: {
                name: "PAN ",
                registration_number : "pan_number"
            },
            registration_10_23c_file_url: {
                name : "10(23C) Reg. No.",
                registration_number : "registration_10_23c_certificate_number"
            },
        },
        Line2: {
            gst_file_url: {
                name: "GSTIN",
                registration_number : "gst_number"
            },
            pf_registration_file_url: {
                name :"PF Reg. No.",
                registration_number : "pf_registration_certificate_number"
            },
        },
        Line3: {
            tan_file_url: {
                name: "TAN ",
                registration_number : "tan_number"
            },
            esi_registration_file_url: {
                name : "ESI Reg. No.",
                registration_number : "esi_registration_certificate_number"
            },

        },
        Line4: {
            registration_12a_file_url: {
                name : "12A Reg. No.",
                registration_number : "registration_12a_certificate_number"
            },
            pt_registration_file_url: {
                name : "PT Reg. No.",
                registration_number : "pt_registration_certificate_number"
            },
        },
        Line5 : {
            registration_80g_file_url: {
                name : "80G Reg. No.",
                registration_number : "registration_80g_certificate_number"
            },
            approval_registration_file_url: {
                name : "Approval No.",
                registration_number : "approval_number"
            },
        }
    }

    /**
     * The function `handelDownload` downloads an S3 object and sets a toast message indicating that
     * the file was downloaded successfully.
     */
    const handelDownload = async(val) => {
        downloadS3Object(val)
        setToastmessage("File downloaded successfully")
    }

    return (
        <>
            
            <div class="mt-[30px] w-[100%] mx-auto">
                <h5 class="text-lg font-semibold text-[#000000] mb-2">Statutory Details</h5>
                <div class="w-full border border-[#D0D5DD] rounded mb-4">
                    <div class="flex flex-wrap">
                        {Object.keys(DocList3).map((item) => (
                            <div key={item} class="border-b border-[#EEF1F4] w-full flex p-4">
                                {Object.keys(DocList3[item]).map((subItem) => (
                                    <div class="w-1/2 " key={subItem}>
                                        <div class="w-full">
                                            <div class="flex items-center">
                                                <div class="w-[77%] 2xl:w-[63%]">
                                                    <div class="flex items-center break-words break-all">
                                                        <label for="pan-field" class="text-f7 font-normal text-[#031624] min-w-[135px] inline-flex pan_uploaded">{DocList3[item][subItem].name}</label>
                                                        {updateDocumentSate[DocList3[item][subItem].registration_number] !== "" ?  
                                                            <p class="text-f7 font-semibold text-[#031624]">{updateDocumentSate[DocList3[item][subItem].registration_number]}</p>
                                                            : <p class="text-f7 font-semibold text-[#031624] pl-[50px]">-</p>
                                                        }
                                                    </div>
                                                </div>
                                                {(updateDocumentSate[subItem] || updateDocumentSate[subItem] !== '') &&
                                                <div class="w-[23%] 2xl:w-[35%] px-2 flex justify-start">
                                                    <button 
                                                        type="button" 
                                                        disabled={(!updateDocumentSate[subItem] || updateDocumentSate[subItem] === '') ? true : false}
                                                        class="relative cursor-pointer border border-[#106EB4] rounded w-fit p-1 onboardInstitution" 
                                                        onClick={()=>handelDownload(updateDocumentSate[subItem])}
                                                    >
                                                        <img loading="lazy" decoding="async" src="/images/download-view-file.svg" alt="img" class="cursor-pointer"/>
                                                    </button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>))}
                            </div>))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ViewProfile;
